export default __webpack_public_path__ + "5c6ade6750b845292bd7c2f0428e23cf.png";